import React from "react";
import { Box, Typography } from "@material-ui/core";
const OptionsDescripton = () => (
  <Box>
    <Typography gutterBottom variant="body2">
      Options practices explore how you weigh your learnings, and possibly
      change the direction you are heading.
    </Typography>
    <Typography variant="body2">
      <i>
        What are the team's possibilities? What might you need to realize your
        target outcomes?
      </i>
    </Typography>
  </Box>
);
export default OptionsDescripton;
